export const appViewportContent = 'width=device-width, initial-scale=1.0, viewport-fit=cover';

type ViewportDocument = Pick<Document, 'createElement' | 'head' | 'querySelector'>;

export function ensureAppViewportMeta(doc: ViewportDocument) {
  const existing = doc.querySelector('meta[name="viewport"]') as HTMLMetaElement | null;
  if (existing) {
    existing.setAttribute('content', appViewportContent);
    return existing;
  }

  const meta = doc.createElement('meta') as HTMLMetaElement;
  meta.setAttribute('name', 'viewport');
  meta.setAttribute('content', appViewportContent);
  doc.head?.appendChild(meta);
  return meta;
}
